<template>
    <div class="error-message" v-if="errorMessage">
    {{ $l[errorMessage] }}
    </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  props: {
    errorMessage: {
      type: String
    }
  },

  mixins: [
    MixinLocale
  ]
}
</script>

<style lang="scss" scoped>
.error-message {
  text-align: center;
  color: #ffffff;
  font-weight: 700;
  margin-bottom: 30px;
  font-weight: normal;
  background-color: #0e6cab;
  padding: 10px 20px;
  margin-top: 20px;
  margin-bottom: 50px;
}
</style>
